import React from 'react';
import _ from 'lodash';

import {
  Timeline,
  TimelineConnector,
  TimelineContent as MuiTimelineContent,
  TimelineDot as MuiTimelineDot,
  TimelineItem,
  timelineItemClasses,
  TimelineSeparator
} from '@mui/lab';
import {
  styled,
  Typography
} from '@mui/material';
import {
  Close,
  Done,
  Loop
} from '@mui/icons-material';

import { DateTime } from 'luxon';
import { ApprovalTypeName } from 'generated/graphql';



const TimelineContent = styled(MuiTimelineContent)(({ theme }) => ({
  paddingBottom: theme.spacing(4)
}));

const TimelineDot = styled(MuiTimelineDot)({
});





export interface IStep {
  completedAt: DateTime | null;
  approvalType: ApprovalTypeName;
  label: string;
}

export interface IProps {
  steps: IStep[];
}

export const FC: React.FC<IProps> = props => {
  const steps = React.useMemo(
    () => _.map(props.steps, (step, index) => (
      <TimelineItem key={index}>

        <TimelineSeparator>
          {__genStepIcon(step)}

          {index !== props.steps.length - 1 && (
            <TimelineConnector />
          )}
        </TimelineSeparator>

        <TimelineContent>
          <Typography variant="h6">
            {step.label}
          </Typography>

          <Typography>
            {step.completedAt?.toFormat('MM/dd/yyyy') ?? "Pending"}
          </Typography>
        </TimelineContent>
      </TimelineItem>
    )),
    [props]
  );

  return (
    <Timeline
      position="right"
      sx={{
        [`& .${timelineItemClasses.root}:before`]: {
          flex: 0,
          padding: 0
        }
      }}>
      {steps}
    </Timeline>
  );
};



function __genStepIcon(step: IStep) {
  if (step.approvalType === 'pending') {
    return (
      <TimelineDot color="grey">
        <Loop />
      </TimelineDot>
    );

  } else if (step.approvalType === 'approved') {
    return (
      <TimelineDot color="success">
        <Done />
      </TimelineDot>
    );

  } else if (step.approvalType === 'denied') {
    return (
      <TimelineDot color="error">
        <Close />
      </TimelineDot>
    );
  }
}
